// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multi-range-slider * {
	box-sizing: border-box;
	padding: 0px;
	margin: 0px;
}
.multi-range-slider {
	display: flex;
	position: relative;
	border: solid 1px gray;
	border-radius: 10px;
	padding: 20px 10px;
	box-shadow: 1px 1px 4px black;
	flex-direction: column;
	-webkit-touch-callout: none; /* iOS Safari */
	-webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
	user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge,*/
}
.multi-range-slider .bar {
	display: flex;
}
.multi-range-slider .bar-left {
	width: 25%;
	background-color: #f0f0f0;
	border-radius: 10px 0px 0px 10px;
	box-shadow: inset 0px 0px 5px black;
	padding: 4px 0px;
}
.multi-range-slider .bar-right {
	width: 25%;
	background-color: #f0f0f0;
	border-radius: 0px 10px 10px 0px;
	box-shadow: inset 0px 0px 5px black;
}
.multi-range-slider .bar-inner {
	background-color: lime;
	display: flex;
	flex-grow: 1;
	flex-shrink: 1;
	position: relative;
	border: solid 1px black;
	justify-content: space-between;
	box-shadow: inset 0px 0px 5px black;
}
.multi-range-slider .bar-inner-left {
	width: 50%;
}
.multi-range-slider .bar-inner-right {
	width: 50%;
}
.multi-range-slider .thumb {
	background-color: white;
	position: relative;
	z-index: 1;
	cursor: pointer;
}
.multi-range-slider .thumb::before {
	content: '';
	background-color: inherit;
	position: absolute;
	width: 20px;
	height: 20px;
	border: solid 1px black;
	box-shadow: 0px 0px 3px black, inset 0px 0px 5px gray;
	border-radius: 50%;
	z-index: 1;
	margin: -8px -12px;
	cursor: pointer;
}
.multi-range-slider .input-type-range:focus + .thumb::after {
	content: '';
	position: absolute;
	top: -4px;
	left: -7px;
	width: 11px;
	height: 11px;
	z-index: 2;
	border-radius: 50%;
	border: dotted 1px black;
	box-shadow: 0px 0px 5px white, inset 0px 0px 10px black;
}
.multi-range-slider .caption {
	position: absolute;
	bottom: 35px;
	width: 2px;
	height: 2px;
	left: 1px;
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: visible;
	display: none;
}
.multi-range-slider .thumb .caption * {
	position: absolute;
	min-width: 30px;
	height: 30px;
	font-size: 75%;
	text-align: center;
	line-height: 30px;
	background-color: blue;
	border-radius: 15px;
	color: white;
	box-shadow: 0px 0px 5px black;
	padding: 0px 5px;
	white-space: nowrap;
}
.multi-range-slider .thumb:active .caption {
	display: flex;
}
.multi-range-slider .input-type-range:focus + .thumb .caption {
	display: flex;
}
.multi-range-slider .input-type-range {
	position: absolute;
	top: 0px;
	left: 0px;
	width: 100%;
	opacity: 0;
	pointer-events: none;
}

.multi-range-slider .ruler {
	margin: 10px 0px -5px 0px;
	display: flex;
	/* display: none; */
	overflow: hidden;
}
.multi-range-slider .ruler .ruler-rule {
	border-left: solid 1px;
	border-bottom: solid 1px;
	display: flex;
	flex-grow: 1;
	flex-shrink: 1;
	padding: 5px 0px;
}
.multi-range-slider .ruler .ruler-rule:last-child {
	border-right: solid 1px;
}

.multi-range-slider .ruler .ruler-sub-rule {
	border-left: solid 1px;
	/* border-bottom: solid 1px; */
	display: flex;
	flex-grow: 1;
	flex-shrink: 1;
	padding: 3px 0px;
	bottom: 0px;
	margin-bottom: -5px;
}
.multi-range-slider .ruler .ruler-sub-rule:first-child {
	border-left: none;
}

.multi-range-slider .labels {
	display: flex;
	justify-content: space-between;
	padding: 0px;
	margin-top: 10px;
	margin-bottom: -20px;
	/* display: none; */
}
.multi-range-slider .label {
	font-size: 80%;
	display: flex;
	width: 1px;
	justify-content: center;
}
.multi-range-slider .label:first-child {
	justify-content: start;
}
.multi-range-slider .label:last-child {
	justify-content: end;
}
.multi-range-slider.zero-ranage-margin .thumb-left {
	right: 12px;
}
.multi-range-slider.zero-ranage-margin .thumb-right {
	left: 8px;
}


/* Disabled */
.multi-range-slider.disabled {
	border: solid 1px rgb(200, 200, 200);
	box-shadow: 1px 1px 4px rgb(180, 180, 180);
	color:rgb(180, 180, 180);
}
.multi-range-slider .bar {
	display: flex;
}
.multi-range-slider.disabled .bar-left {
	background-color: #c9c9c9;
	box-shadow: inset 0px 0px 5px rgb(160, 160, 160);
}
.multi-range-slider.disabled .bar-right {
	background-color: #c9c9c9;
	box-shadow: inset 0px 0px 5px rgb(160, 160, 160);
}
.multi-range-slider.disabled .bar-inner {
	background-color: rgb(130 243 130);
	border: solid 1px rgb(149, 149, 149);
	box-shadow: inset 0px 0px 5px rgb(103, 103, 103);
}
.multi-range-slider.disabled .thumb {
	background-color: white;
}
.multi-range-slider.disabled .thumb::before {
	border: solid 1px rgb(200, 200, 200);
	box-shadow: 0px 0px 3px rgb(35, 35, 35), inset 0px 0px 5px gray;
}
.multi-range-slider.disabled .input-type-range:focus + .thumb::after {
	border: dotted 1px rgb(35, 35, 35);
	box-shadow: 0px 0px 5px white, inset 0px 0px 10px rgb(35, 35, 35);
}
.multi-range-slider.disabled .thumb .caption * {
	background-color: rgb(84, 84, 137);
	color: rgb(199, 199, 199);
	box-shadow: 0px 0px 5px rgb(35, 35, 35);
}


`, "",{"version":3,"sources":["webpack://./node_modules/multi-range-slider-react/lib/multirangeslider.css"],"names":[],"mappings":"AAAA;CACC,sBAAsB;CACtB,YAAY;CACZ,WAAW;AACZ;AACA;CACC,aAAa;CACb,kBAAkB;CAClB,sBAAsB;CACtB,mBAAmB;CACnB,kBAAkB;CAClB,6BAA6B;CAC7B,sBAAsB;CACtB,2BAA2B,EAAE,eAAe;CAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;CAClD,iBAAiB,EAAE,8DAA8D;AAClF;AACA;CACC,aAAa;AACd;AACA;CACC,UAAU;CACV,yBAAyB;CACzB,gCAAgC;CAChC,mCAAmC;CACnC,gBAAgB;AACjB;AACA;CACC,UAAU;CACV,yBAAyB;CACzB,gCAAgC;CAChC,mCAAmC;AACpC;AACA;CACC,sBAAsB;CACtB,aAAa;CACb,YAAY;CACZ,cAAc;CAEd,kBAAkB;CAClB,uBAAuB;CACvB,8BAA8B;CAC9B,mCAAmC;AACpC;AACA;CACC,UAAU;AACX;AACA;CACC,UAAU;AACX;AACA;CACC,uBAAuB;CACvB,kBAAkB;CAClB,UAAU;CACV,eAAe;AAChB;AACA;CACC,WAAW;CACX,yBAAyB;CACzB,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,uBAAuB;CACvB,qDAAqD;CACrD,kBAAkB;CAClB,UAAU;CACV,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,WAAW;CACX,YAAY;CACZ,UAAU;CACV,kBAAkB;CAClB,wBAAwB;CACxB,uDAAuD;AACxD;AACA;CACC,kBAAkB;CAClB,YAAY;CACZ,UAAU;CACV,WAAW;CACX,SAAS;CACT,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,iBAAiB;CACjB,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,eAAe;CACf,YAAY;CACZ,cAAc;CACd,kBAAkB;CAClB,iBAAiB;CACjB,sBAAsB;CACtB,mBAAmB;CACnB,YAAY;CACZ,6BAA6B;CAC7B,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,WAAW;CACX,UAAU;CACV,oBAAoB;AACrB;;AAEA;CACC,yBAAyB;CACzB,aAAa;CACb,mBAAmB;CACnB,gBAAgB;AACjB;AACA;CACC,sBAAsB;CACtB,wBAAwB;CACxB,aAAa;CACb,YAAY;CACZ,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,uBAAuB;AACxB;;AAEA;CACC,sBAAsB;CACtB,8BAA8B;CAC9B,aAAa;CACb,YAAY;CACZ,cAAc;CACd,gBAAgB;CAChB,WAAW;CACX,mBAAmB;AACpB;AACA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,YAAY;CACZ,gBAAgB;CAChB,oBAAoB;CACpB,mBAAmB;AACpB;AACA;CACC,cAAc;CACd,aAAa;CACb,UAAU;CACV,uBAAuB;AACxB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,WAAW;AACZ;AACA;CACC,SAAS;AACV;;;AAGA,aAAa;AACb;CACC,oCAAoC;CACpC,0CAA0C;CAC1C,wBAAwB;AACzB;AACA;CACC,aAAa;AACd;AACA;CACC,yBAAyB;CACzB,gDAAgD;AACjD;AACA;CACC,yBAAyB;CACzB,gDAAgD;AACjD;AACA;CACC,kCAAkC;CAClC,oCAAoC;CACpC,gDAAgD;AACjD;AACA;CACC,uBAAuB;AACxB;AACA;CACC,oCAAoC;CACpC,+DAA+D;AAChE;AACA;CACC,kCAAkC;CAClC,iEAAiE;AAClE;AACA;CACC,kCAAkC;CAClC,yBAAyB;CACzB,uCAAuC;AACxC","sourcesContent":[".multi-range-slider * {\r\n\tbox-sizing: border-box;\r\n\tpadding: 0px;\r\n\tmargin: 0px;\r\n}\r\n.multi-range-slider {\r\n\tdisplay: flex;\r\n\tposition: relative;\r\n\tborder: solid 1px gray;\r\n\tborder-radius: 10px;\r\n\tpadding: 20px 10px;\r\n\tbox-shadow: 1px 1px 4px black;\r\n\tflex-direction: column;\r\n\t-webkit-touch-callout: none; /* iOS Safari */\r\n\t-webkit-user-select: none; /* Safari */\r\n\t-khtml-user-select: none; /* Konqueror HTML */\r\n\t-moz-user-select: none; /* Old versions of Firefox */\r\n\t-ms-user-select: none; /* Internet Explorer/Edge */\r\n\tuser-select: none; /* Non-prefixed version, currently supported by Chrome, Edge,*/\r\n}\r\n.multi-range-slider .bar {\r\n\tdisplay: flex;\r\n}\r\n.multi-range-slider .bar-left {\r\n\twidth: 25%;\r\n\tbackground-color: #f0f0f0;\r\n\tborder-radius: 10px 0px 0px 10px;\r\n\tbox-shadow: inset 0px 0px 5px black;\r\n\tpadding: 4px 0px;\r\n}\r\n.multi-range-slider .bar-right {\r\n\twidth: 25%;\r\n\tbackground-color: #f0f0f0;\r\n\tborder-radius: 0px 10px 10px 0px;\r\n\tbox-shadow: inset 0px 0px 5px black;\r\n}\r\n.multi-range-slider .bar-inner {\r\n\tbackground-color: lime;\r\n\tdisplay: flex;\r\n\tflex-grow: 1;\r\n\tflex-shrink: 1;\r\n\tjustify-content: space-between;\r\n\tposition: relative;\r\n\tborder: solid 1px black;\r\n\tjustify-content: space-between;\r\n\tbox-shadow: inset 0px 0px 5px black;\r\n}\r\n.multi-range-slider .bar-inner-left {\r\n\twidth: 50%;\r\n}\r\n.multi-range-slider .bar-inner-right {\r\n\twidth: 50%;\r\n}\r\n.multi-range-slider .thumb {\r\n\tbackground-color: white;\r\n\tposition: relative;\r\n\tz-index: 1;\r\n\tcursor: pointer;\r\n}\r\n.multi-range-slider .thumb::before {\r\n\tcontent: '';\r\n\tbackground-color: inherit;\r\n\tposition: absolute;\r\n\twidth: 20px;\r\n\theight: 20px;\r\n\tborder: solid 1px black;\r\n\tbox-shadow: 0px 0px 3px black, inset 0px 0px 5px gray;\r\n\tborder-radius: 50%;\r\n\tz-index: 1;\r\n\tmargin: -8px -12px;\r\n\tcursor: pointer;\r\n}\r\n.multi-range-slider .input-type-range:focus + .thumb::after {\r\n\tcontent: '';\r\n\tposition: absolute;\r\n\ttop: -4px;\r\n\tleft: -7px;\r\n\twidth: 11px;\r\n\theight: 11px;\r\n\tz-index: 2;\r\n\tborder-radius: 50%;\r\n\tborder: dotted 1px black;\r\n\tbox-shadow: 0px 0px 5px white, inset 0px 0px 10px black;\r\n}\r\n.multi-range-slider .caption {\r\n\tposition: absolute;\r\n\tbottom: 35px;\r\n\twidth: 2px;\r\n\theight: 2px;\r\n\tleft: 1px;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\toverflow: visible;\r\n\tdisplay: none;\r\n}\r\n.multi-range-slider .thumb .caption * {\r\n\tposition: absolute;\r\n\tmin-width: 30px;\r\n\theight: 30px;\r\n\tfont-size: 75%;\r\n\ttext-align: center;\r\n\tline-height: 30px;\r\n\tbackground-color: blue;\r\n\tborder-radius: 15px;\r\n\tcolor: white;\r\n\tbox-shadow: 0px 0px 5px black;\r\n\tpadding: 0px 5px;\r\n\twhite-space: nowrap;\r\n}\r\n.multi-range-slider .thumb:active .caption {\r\n\tdisplay: flex;\r\n}\r\n.multi-range-slider .input-type-range:focus + .thumb .caption {\r\n\tdisplay: flex;\r\n}\r\n.multi-range-slider .input-type-range {\r\n\tposition: absolute;\r\n\ttop: 0px;\r\n\tleft: 0px;\r\n\twidth: 100%;\r\n\topacity: 0;\r\n\tpointer-events: none;\r\n}\r\n\r\n.multi-range-slider .ruler {\r\n\tmargin: 10px 0px -5px 0px;\r\n\tdisplay: flex;\r\n\t/* display: none; */\r\n\toverflow: hidden;\r\n}\r\n.multi-range-slider .ruler .ruler-rule {\r\n\tborder-left: solid 1px;\r\n\tborder-bottom: solid 1px;\r\n\tdisplay: flex;\r\n\tflex-grow: 1;\r\n\tflex-shrink: 1;\r\n\tpadding: 5px 0px;\r\n}\r\n.multi-range-slider .ruler .ruler-rule:last-child {\r\n\tborder-right: solid 1px;\r\n}\r\n\r\n.multi-range-slider .ruler .ruler-sub-rule {\r\n\tborder-left: solid 1px;\r\n\t/* border-bottom: solid 1px; */\r\n\tdisplay: flex;\r\n\tflex-grow: 1;\r\n\tflex-shrink: 1;\r\n\tpadding: 3px 0px;\r\n\tbottom: 0px;\r\n\tmargin-bottom: -5px;\r\n}\r\n.multi-range-slider .ruler .ruler-sub-rule:first-child {\r\n\tborder-left: none;\r\n}\r\n\r\n.multi-range-slider .labels {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\tpadding: 0px;\r\n\tmargin-top: 10px;\r\n\tmargin-bottom: -20px;\r\n\t/* display: none; */\r\n}\r\n.multi-range-slider .label {\r\n\tfont-size: 80%;\r\n\tdisplay: flex;\r\n\twidth: 1px;\r\n\tjustify-content: center;\r\n}\r\n.multi-range-slider .label:first-child {\r\n\tjustify-content: start;\r\n}\r\n.multi-range-slider .label:last-child {\r\n\tjustify-content: end;\r\n}\r\n.multi-range-slider.zero-ranage-margin .thumb-left {\r\n\tright: 12px;\r\n}\r\n.multi-range-slider.zero-ranage-margin .thumb-right {\r\n\tleft: 8px;\r\n}\r\n\r\n\r\n/* Disabled */\r\n.multi-range-slider.disabled {\r\n\tborder: solid 1px rgb(200, 200, 200);\r\n\tbox-shadow: 1px 1px 4px rgb(180, 180, 180);\r\n\tcolor:rgb(180, 180, 180);\r\n}\r\n.multi-range-slider .bar {\r\n\tdisplay: flex;\r\n}\r\n.multi-range-slider.disabled .bar-left {\r\n\tbackground-color: #c9c9c9;\r\n\tbox-shadow: inset 0px 0px 5px rgb(160, 160, 160);\r\n}\r\n.multi-range-slider.disabled .bar-right {\r\n\tbackground-color: #c9c9c9;\r\n\tbox-shadow: inset 0px 0px 5px rgb(160, 160, 160);\r\n}\r\n.multi-range-slider.disabled .bar-inner {\r\n\tbackground-color: rgb(130 243 130);\r\n\tborder: solid 1px rgb(149, 149, 149);\r\n\tbox-shadow: inset 0px 0px 5px rgb(103, 103, 103);\r\n}\r\n.multi-range-slider.disabled .thumb {\r\n\tbackground-color: white;\r\n}\r\n.multi-range-slider.disabled .thumb::before {\r\n\tborder: solid 1px rgb(200, 200, 200);\r\n\tbox-shadow: 0px 0px 3px rgb(35, 35, 35), inset 0px 0px 5px gray;\r\n}\r\n.multi-range-slider.disabled .input-type-range:focus + .thumb::after {\r\n\tborder: dotted 1px rgb(35, 35, 35);\r\n\tbox-shadow: 0px 0px 5px white, inset 0px 0px 10px rgb(35, 35, 35);\r\n}\r\n.multi-range-slider.disabled .thumb .caption * {\r\n\tbackground-color: rgb(84, 84, 137);\r\n\tcolor: rgb(199, 199, 199);\r\n\tbox-shadow: 0px 0px 5px rgb(35, 35, 35);\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
